import { defineNuxtPlugin, useRuntimeConfig } from '#app'
import Hotjar from '@hotjar/browser'

export default defineNuxtPlugin(() => {
  const hotjarOptions = useRuntimeConfig().public.hotjar

  if (hotjarOptions.debug) {
    // eslint-disable-next-line no-console
    console.log(
      "%c You're in dev mode",
      'color: #000000; background-color: #f79859; font-weight: bold; padding: 4px; border-radius: 5px',
    )
  }

  if (!hotjarOptions.id) {
    // eslint-disable-next-line no-console
    console.log(
      '%c No hotjarId found',
      'color: #000000; background-color: #f79859; font-weight: bold; padding: 4px; border-radius: 5px',
    )
    return
  }

  const init = clientOnly(() =>
    Hotjar.init(hotjarOptions.id, 6, {
      debug: hotjarOptions.debug,
    }),
  )

  init()
})
